import React from 'react';
import { EventAssignmentLoadingProvider } from '../contexts/EventAssignmentLoadingContext';

/**
 * @typedef {object} EventAssignmentLoadingDataProviderProps
 * @property {React.ReactNode} [children]
 * @property {boolean} [assignmentsLoading]
 */

/**
 * @param {EventAssignmentLoadingDataProviderProps} props
 */
const EventAssignmentLoadingDataProvider = props => {
  const { children, assignmentsLoading } = props;

  return (
    <EventAssignmentLoadingProvider value={assignmentsLoading}>
      {children}
    </EventAssignmentLoadingProvider>
  );
};

export default EventAssignmentLoadingDataProvider;
